























import Vue from 'vue';
import JobsSidebar from '~/components/navigation/jobs/JobsSidebar.vue';
import ExpiredJobHiredQuestionModal from "~/components/jobs/ExpiredJobHiredQuestionModal.vue";
import CompanyVerificationPanel from "~/components/account/CompanyVerificationPanel.vue";

export default Vue.extend({
    name: 'default',
    components: {CompanyVerificationPanel, ExpiredJobHiredQuestionModal, JobsSidebar },
    computed: {
        viewingJobOrBursary() {
            const id = this.$route.params.id;
            const regex = new RegExp(`(jobs|bursaries)/${id}`);
            return regex.test(this.$route.fullPath);
        },

        userHasCompany() {
            return Boolean(this.$auth.user?.company);
        },

        expiredJobs(){
          return this.$store.getters['jobs/getExpiredJobs'];
        }
    },
    mounted() {
        this.getCompanyDetails();

        if (!this.$auth.user?.company) {
            return this.$router.push(this.localePath({ path: '/company/create' }));
        }
    },
    methods: {
        async getCompanyDetails() {
            await this.$store
                .dispatch('getCompanyDetails')
                .then((response) => {})
                .catch((error) => {});
        },
    },
});
